// @flow

interface IYandexSmartCaptchaInvisibleOptions {
	// Html element id
	id: ?string,
}

export class YandexSmartCaptchaInvisibleModel {
	constructor (options: IYandexSmartCaptchaInvisibleOptions) {
		this.elementId = options.id || 'captcha-container';
	}
}